var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],ref:"palletHourChart",attrs:{"id":"palletHourChart","width":"400","height":"400"}})}
var staticRenderFns = []

export { render, staticRenderFns }